import type { AisPosition } from '../types/generated-data';
import type { WaypointType } from '../types/waypoint-type';

/** Apply the anomaly implied by a waypoint type to a freshly built position. */
export function applyWaypointAnomaly(
  pos: AisPosition,
  waypointType: WaypointType | undefined,
): AisPosition {
  if (waypointType === 'transponder_off') {
    return {
      ...pos,
      latitude: 91,
      longitude: 181,
      speed_over_ground_kn: 0,
      heading_deg: 511,
      course_over_ground_deg: 360,
      anomaly: 'transponder_off',
    };
  }
  if (waypointType === 'outlier') {
    return { ...pos, anomaly: 'position_outlier' };
  }
  return pos;
}
